import { AuditEntityTypes } from "@tm-food/api-contract";

/** Nhãn tiếng Việt cho thao tác audit (BE `action`). */
const AUDIT_ACTION_LABEL: Record<string, string> = {
  Create: "Tạo",
  Update: "Cập nhật",
  Upsert: "Lưu / cập nhật",
  Confirm: "Xác nhận",
  AutoCreateDeposit: "Tạo phiếu cọc tự động",
  ConfirmPolicyWarn: "Cảnh báo khi xác nhận",
  Cancel: "Hủy",
  Close: "Đóng",
  Hold: "Tạm giữ",
  Unhold: "Gỡ tạm giữ",
  Lock: "Khóa tài khoản",
  Unlock: "Mở khóa",
  ResetPassword: "Đặt lại mật khẩu",
  AssignRole: "Gán vai trò",
  UnassignRole: "Gỡ vai trò",
  CreateDemandFromLine: "Tạo nhu cầu sản xuất",
  SyncFulfillmentStatus: "Cập nhật tình trạng thực hiện",
  Delete: "Xóa",
  Submit: "Gửi duyệt",
  Approve: "Phê duyệt",
  Reject: "Từ chối",
  SetEffective: "Đặt hiệu lực",
  SetStatus: "Cập nhật trạng thái",
  CreatePurchaseOrder: "Tạo đơn mua hàng",
  CreateSalesOrder: "Tạo đơn bán",
  CreateAddress: "Thêm địa chỉ",
  UpdateAddress: "Sửa địa chỉ",
  DeleteAddress: "Xóa địa chỉ",
  CreateConversion: "Thêm quy đổi ĐVT",
  UpdateConversion: "Sửa quy đổi ĐVT",
  DeleteConversion: "Xóa quy đổi ĐVT",
  Receipt: "Nhận hàng",
  PrepareReceipt: "Chuẩn bị nhận hàng",
  Ship: "Giao hàng",
  CreditLimitApproved: "Duyệt hạn mức tín dụng",
  DebtSegmentApproved: "Duyệt phân khúc công nợ",
  Post: "Ghi sổ",
  Release: "Phát hành",
  Complete: "Hoàn tất",
  Start: "Bắt đầu",
  Pause: "Tạm dừng",
  Resume: "Tiếp tục",
};

/** Nhãn tiếng Việt cho loại thực thể audit. */
const AUDIT_ENTITY_LABEL: Record<string, string> = {
  [AuditEntityTypes.AppUser]: "Tài khoản",
  [AuditEntityTypes.Role]: "Vai trò",
  SysRole: "Vai trò",
  [AuditEntityTypes.Plant]: "Nhà máy",
  [AuditEntityTypes.ProductionLine]: "Dây chuyền",
  [AuditEntityTypes.Organization]: "Tổ chức",
  [AuditEntityTypes.SalesOrder]: "Đơn bán",
  [AuditEntityTypes.Shipment]: "Phiếu giao hàng",
  [AuditEntityTypes.PurchaseRequisition]: "Đề nghị mua",
  [AuditEntityTypes.PurchaseOrder]: "Đơn mua",
  [AuditEntityTypes.Demand]: "Nhu cầu SX",
  [AuditEntityTypes.ProductionOrder]: "Lệnh sản xuất",
  [AuditEntityTypes.Batch]: "Mẻ",
  [AuditEntityTypes.Lot]: "Lô",
  [AuditEntityTypes.InventoryTxn]: "Giao dịch kho",
  StockCount: "Kiểm kê",
  StockDisposal: "Hủy hàng",
  [AuditEntityTypes.Inspection]: "Kiểm tra",
  [AuditEntityTypes.QaRelease]: "Xuất kho QA",
  [AuditEntityTypes.Ncr]: "NCR",
  [AuditEntityTypes.Hold]: "Lệnh giữ",
  [AuditEntityTypes.Bom]: "Định mức BOM",
  [AuditEntityTypes.Routing]: "Quy trình",
  [AuditEntityTypes.Spec]: "Tiêu chuẩn kỹ thuật",
  [AuditEntityTypes.QcPlan]: "Mẫu QC",
  [AuditEntityTypes.TechnicalInfo]: "Thông tin kỹ thuật",
  [AuditEntityTypes.Product]: "Sản phẩm",
  [AuditEntityTypes.ProductType]: "Loại sản phẩm",
  [AuditEntityTypes.OperationTemplate]: "Mẫu công đoạn",
  [AuditEntityTypes.Partner]: "Đối tác",
  PartnerCreditLimitChange: "Phiếu hạn mức tín dụng",
  PartnerDebtSegmentChange: "Phiếu phân khúc công nợ",
  [AuditEntityTypes.FinReceipt]: "Phiếu thu",
  [AuditEntityTypes.FinPayment]: "Phiếu chi",
  [AuditEntityTypes.Item]: "Mặt hàng",
  [AuditEntityTypes.Equipment]: "Thiết bị",
  [AuditEntityTypes.Warehouse]: "Kho hàng",
  [AuditEntityTypes.Location]: "Vị trí",
  [AuditEntityTypes.ReasonCode]: "Mã lý do",
  [AuditEntityTypes.ApprovalPolicy]: "Chính sách phê duyệt",
  [AuditEntityTypes.ApprovalInstance]: "Phiếu phê duyệt",
  [AuditEntityTypes.ApprovalRequest]: "Yêu cầu phê duyệt",
  [AuditEntityTypes.NavGroup]: "Nhóm menu",
  [AuditEntityTypes.NavItem]: "Mục menu",
  [AuditEntityTypes.NavProfile]: "Hồ sơ menu",
  [AuditEntityTypes.NotificationEventDefinition]: "Sự kiện thông báo",
  FormInstance: "Biểu mẫu",
  Document: "Tài liệu",
  DocumentMaster: "Mẫu tài liệu",
  NumberingSeries: "Số chứng từ",
  AppSetting: "Cấu hình hệ thống",
  Category: "Danh mục",
  CategoryDetail: "Chi tiết danh mục",
  Uom: "Đơn vị tính",
  UomConversion: "Quy đổi ĐVT",
};

export function auditActionLabel(action: string): string {
  const key = action?.trim() ?? "";
  if (!key) return "—";
  return AUDIT_ACTION_LABEL[key] ?? key;
}

export function auditEntityTypeLabel(entityType: string): string {
  const key = entityType?.trim() ?? "";
  if (!key) return "—";
  return AUDIT_ENTITY_LABEL[key] ?? key;
}

/** Options lọc loại thực thể (value = mã BE, label = VI). */
export function auditEntityTypeFilterOptions(): Array<{
  value: string;
  label: string;
}> {
  return [
    { value: "all", label: "Tất cả" },
    ...Object.values(AuditEntityTypes)
      .map((v) => ({ value: v, label: auditEntityTypeLabel(v) }))
      .sort((a, b) => a.label.localeCompare(b.label, "vi")),
  ];
}
